import React from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export interface Props {
  img: any
}

const Container = styled(GatsbyImage)<any>`
  width: 100%;
  height: 100%;
`

const Image: React.FC<Props> = ({ img }: Props) => {
  const image = getImage(img?.childImageSharp?.gatsbyImageData || img)
  if (!image) return null
  return <Container image={image} alt="" />
}

export default Image
